import { render, staticRenderFns } from "./alertItem.vue?vue&type=template&id=5abfb6e1&scoped=true&lang=pug"
import script from "./alertItem.vue?vue&type=script&lang=js"
export * from "./alertItem.vue?vue&type=script&lang=js"
import style0 from "./alertItem.vue?vue&type=style&index=0&id=5abfb6e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abfb6e1",
  null
  
)

export default component.exports